module.exports = __webpack_public_path__ + "media/interview-philippe-nonie.8f46f8ab.mp3";